var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('ul',{key:`item-${index}`},[_c('li',[_c('a',{attrs:{"href":_vm.links[item][_vm.language].link},domProps:{"innerHTML":_vm._s(_vm.links[item][_vm.language].text)}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }